import React from 'react';
import './FeatureTag.css';

/**
 * FeatureTag Component
 * Feature tag/badge component
 * 
 * @param {string} text - Tag text
 * @param {string} variant - Tag variant: 'default'|'primary'|'secondary' (default: 'default')
 * @param {string} className - Additional CSS classes
 */
const FeatureTag = ({ text, variant = 'default', className = '' }) => {
  const variantClass = variant === 'primary' ? 'feature-tag-primary' : 
                       variant === 'secondary' ? 'feature-tag-secondary' : 
                       'feature-tag-default';
  
  return (
    <div className={`feature-tag ${variantClass} ${className}`.trim()}>
      {text}
    </div>
  );
};

export default FeatureTag;























